//
//
//
//
//
//
//
//

import UploadIndex from '@/components/uploadPicture/index.vue';
export default {
  name: 'index',
  data: function data() {
    return {
      pictureType: 'maintain'
    };
  },
  components: {
    UploadIndex: UploadIndex
  }
};